import { render, staticRenderFns } from "./PortfolioCardWithDonutChart.vue?vue&type=template&id=d5f60574"
import script from "./PortfolioCardWithDonutChart.vue?vue&type=script&lang=js"
export * from "./PortfolioCardWithDonutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,PortfolioRankTag: require('/skade-pwa/components/ui/atom/PortfolioRankTag.vue').default,PortfolioPrivacyTag: require('/skade-pwa/components/ui/atom/PortfolioPrivacyTag.vue').default,ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default})
